import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { Department } from '../../models/lawyers/department';

@Component({
  selector: 'app-department-create-edit',
  templateUrl: './department-create-edit.component.html',
  styleUrls: ['./department-create-edit.component.scss']
})
export class DepartmentCreateEditComponent implements OnInit {

  public department: Department;

  @ViewChild('departmentsModal') departmentsModal;
  @Output() submit: EventEmitter<Department> = new EventEmitter<Department>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: LawyersApiService,
    private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(department: Department) {
    this.department = Object.assign(new Department(), department);
    this.modalRef = this.modalService.open(this.departmentsModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });

  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit() {
    if (this.department.id) {
      this.spinner.show();
      this.api.updateDepartment(this.department).subscribe(
        d => {
          this.spinner.hide();
          this.submit.emit(d);
          this.closeModal.emit();
        }
      )
    } else {
      this.spinner.show();
      this.api.createDepartment(this.department).subscribe(
        d => {
          this.spinner.hide();
          this.submit.emit(d);
          this.closeModal.emit();
        }
      )
    }
  }


}
